import React from 'react';
import { Permission } from '../../data/models/permission.model';
import { useAppSelector } from '../useAppSelector';
import { useHasPermission } from './useHasPermission';
import * as userSlice from '../../data/user.slice';

export const useCanDeleteVehicle = (): boolean => {
  const [canDeleteVehicle, setCanDeleteVehicle] =
    React.useState<boolean>(false);
  const user = useAppSelector(userSlice.selectUserInfo);

  const deleteAllPermission: Permission = {
    resource: 'vehicles',
    action: 'deletebasic',
    scope: 'all',
  };
  const deleteProviderPermission: Permission = {
    resource: 'vehicles',
    action: 'deletebasic',
    scope: 'provider',
  };

  const canDeleteAll = useHasPermission(user, deleteAllPermission);
  const canDeleteProvider = useHasPermission(user, deleteProviderPermission);

  React.useEffect(() => {
    setCanDeleteVehicle(canDeleteAll || canDeleteProvider);
  }, [canDeleteAll, canDeleteProvider]);

  return canDeleteVehicle;
};
